/*
  System Info State - Actions.
*/

import {
  CHANGE_FILTER,
  CHANGE_PAGINATION,
  GET_AUDIT_LOG_DATA,
  TOGGLE_FEATURE_FLAGS_LOADING,
  GET_FEATURE_FLAGS_DATA,
  SET_FEATURE_FLAG_DATA,
  GET_SYSTEM_SETTINGS_DATA,
  TOGGLE_AUDIT_LOG_TABLE_LOADING,
  TOGGLE_SYSTEM_SETTINGS_LOADING,
  SET_TEST_EMAIL_MODAL_STATE,
  COLLECT_SYSTEM_SETTINGS_REQUEST_DATA,
} from './mutation-types';
import { axiosClient } from '@/core/services/http.service';
import { camelCaseToString, getEntryType } from '@/core/utils';

export async function getAuditLogData({ commit }, params) {
  commit(TOGGLE_AUDIT_LOG_TABLE_LOADING, true);
  const { success, body } = await axiosClient.post('/api/SystemInfo/audit', params);
  if (success) {
    commit(GET_AUDIT_LOG_DATA, body);
  }
  commit(TOGGLE_AUDIT_LOG_TABLE_LOADING, false);
}

/**
 * Query Feature Flags via API and assign to State.
 * - Assign 'version 4' to app.isFourthVersion.
 */
export async function getFeatureFlagsData({ state, getters, commit, dispatch }) {
  commit(TOGGLE_FEATURE_FLAGS_LOADING, true);
  const { success, body } = await axiosClient.get('/api/SystemInfo/get-feature-flags');
  if (success) {
    commit(GET_FEATURE_FLAGS_DATA, body);
    dispatch('app/changeVersion', getters.getFeatureFlagValue_Version4, { root: true });
  }
  commit(TOGGLE_FEATURE_FLAGS_LOADING, false);
}

/**
 * Store the Fetaure Flag via the BE API, update the State and app.isFourthVersion if needed.
 * @param {*} data Feature Flag data.
 * @returns {*} { success, body } response from API.
 */
export async function setFeatureFlagsData({ commit, getters, dispatch }, data) {
  const { success, body } = await axiosClient.post('/api/systeminfo/update-feature-flag', data);
  if (success) {
    commit(SET_FEATURE_FLAG_DATA, data);
    if (getters.isFeatureFlag_Version4(data))
      dispatch('app/changeVersion', data.enabled, { root: true });
  }
  return { success, body };
}

export async function getSystemSettingsData({ commit }) {
  commit(TOGGLE_SYSTEM_SETTINGS_LOADING, true);
  const { success, body } = await axiosClient.get('/api/systeminfo/systemsettings');
  if (success) {
    const pageData = [];
    const createConfig = (obj) => {
      const items = [];
      for (const item in obj) {
        items.push({
          id: Math.random(),
          fieldId: item,
          label: camelCaseToString(item),
          type: getEntryType(item, obj[item]),
          value: obj[item],
        });
      }
      return items;
    };

    for (const item in body) {
      const finalEl = {
        id: Math.random(),
        cardId: item,
        title: camelCaseToString(item),
        items: [],
      };
      for (const val in body[item]) {
        const isEntryTypeObject = typeof body[item][val] === 'object';
        finalEl.items.push({
          itemId: val,
          label: camelCaseToString(val),
          type: getEntryType(val, body[item][val]),
          [isEntryTypeObject ? 'subItems' : 'value']: !isEntryTypeObject
            ? body[item][val] || window.location.host
            : createConfig(body[item][val]),
        });
      }
      pageData.push(finalEl);
    }
    commit(GET_SYSTEM_SETTINGS_DATA, pageData);
  }
  commit(TOGGLE_SYSTEM_SETTINGS_LOADING, false);
}

export const collectSystemSettingsRequestData = ({ commit }, payload) => {

  const { isModal, fields, item, modalValues } = payload;
  const getInnerFields = (el) => {
    const map = {};
    if ('subItems' in el) {
      el.subItems.forEach(el => {
        map[el.fieldId] = el.value;
      });
      return map;
    } else {
      return el.value;
    }
  };

  const map = {};
  fields.forEach(el => {
    map[el.itemId] = getInnerFields(el);
  });

  commit(
    COLLECT_SYSTEM_SETTINGS_REQUEST_DATA,
    isModal ? { [item]: map, ...modalValues } : { [item]: map });
};
export async function setSystemSettingsData({ commit }, data) {
  const { success } = await axiosClient.post('/api/systeminfo/systemsettings', data);
  return success;
}

export const setTestEmailModalState = ({ commit }, payload) => {
  commit(SET_TEST_EMAIL_MODAL_STATE, payload);
};

export const sendTestEmail = async ({ commit }, data) => {
  const { success } = await axiosClient.post('/api/systeminfo/send-test-email', data);
  return success;
};
export function changePagination({ commit }, params) {
  commit(CHANGE_PAGINATION, params);
}

export function changeFilter({ commit }, params) {
  commit(CHANGE_FILTER, params);
}